import { Text, type TextProps } from "@mantine/core";

function Card(textProps: TextProps) {
  const { style, ...restProps } = textProps;
  const combinedStyle = { cursor: "default", ...style };
  return <Text style={combinedStyle} {...restProps} />;
}

export function YellowCard(textProps: TextProps) {
  return <Card {...textProps}>🟨</Card>;
}

export function RedCard(textProps: TextProps) {
  return <Card {...textProps}>🟥</Card>;
}
